import React from "react";
import "./header.scss";
import { persianDate } from "../../utils/persianDate";
import { intlDate } from "../../utils/intlDate";
import Logo from "../../assets/images/logo.svg";
import Hamburger from "../../assets/images/hamburger.svg";

function Header({toggleSideBar}) {
  const dateText = persianDate("long").dateText;
  const gregorianDate = intlDate();

  return (
    <div className="header">
      <img src={Logo} className="logo" alt="logo" />
      {/* <div className="menu">
        <input type="checkbox" id="btnControl" />
        <p className="close">بستن</p>
        <img src={Hamburger} className="hamburger" alt="icon" />
        <span className="menuItem">
          <div className="item"></div>
        </span>
      </div> */}
      <div className="date flex flex-column align-center justify-center">
        <div>{dateText}</div>
        <div className="en">{gregorianDate}</div>
      </div>
      <img src={Hamburger} className="hamburger" alt="icon" onClick={toggleSideBar} />
    </div>
  );
}
export default Header;
